// assignmentText.js — 1:1 배정 줄의 기간·급여 조건 글자 (2026-10-06 AssignmentBoardCard.jsx 에서 글자 그대로 분리 — 휴대폰 화면도 같이 씀)
import { fmtDate } from './assignmentStatus';

export function periodText(row) {
  return `${fmtDate(row.start_date)} ~ ${row.end_date ? fmtDate(row.end_date) : '진행중'}`;
}

/** 'YYYY-MM-DD' → 'M/D' (글자 계산) */
export function shortMd(value) {
  const text = fmtDate(value);
  return text ? `${Number(text.slice(5, 7))}/${Number(text.slice(8, 10))}` : '';
}

/** 오늘 기준 날짜 배지(2026-10-06 UX): 근무 중 / 10/15 시작 / 10/31까지 / 10/3 끝남.
 *  보드의 묶음(이번 달·예정·종료 — assignmentStatus.getStatus)은 그대로 두고 보이는 글자만 날짜로 알려 준다. */
export function statusText(row, today) {
  const start = fmtDate(row.start_date);
  const end = row.end_date ? fmtDate(row.end_date) : '';
  if (start && today && start > today) return `${shortMd(start)} 시작`;
  if (end && today && end < today) return `${shortMd(end)} 끝남`;
  if (end) return `${shortMd(end)}까지`;
  return '근무 중';
}

/** 배지 색 — 근무 중(초록) / 시작 전(파랑) / 끝남(회색) */
export function statusTone(row, today) {
  const start = fmtDate(row.start_date);
  const end = row.end_date ? fmtDate(row.end_date) : '';
  if (start && today && start > today) return 'upcoming';
  if (end && today && end < today) return 'ended';
  return 'active';
}

/** 오늘 기준 묶음 건수(배지와 같은 판정) — { active, upcoming, ended } */
export function countByToday(rows, today) {
  return rows.reduce((acc, row) => {
    acc[statusTone(row, today)] += 1;
    return acc;
  }, { active: 0, upcoming: 0, ended: 0 });
}

/** 근무 중 → 시작 예정 → 끝남, 같은 묶음은 시작일·이름 순 */
export function sortByToday(rows, today) {
  const order = { active: 0, upcoming: 1, ended: 2 };
  return [...rows].sort((a, b) => (
    order[statusTone(a, today)] - order[statusTone(b, today)]
    || String(fmtDate(a.start_date)).localeCompare(String(fmtDate(b.start_date)))
    || String(a.consultant_name || '').localeCompare(String(b.consultant_name || ''), 'ko')
  ));
}

/** 'YYYY-MM-DD' → 'M월 D일' (글자 계산) */
export function todayLabel(today) {
  const text = String(today || '');
  return text.length >= 10 ? `${Number(text.slice(5, 7))}월 ${Number(text.slice(8, 10))}일` : text;
}

export function latestRule(row) {
  const rules = [...(row.billing_rules || [])].sort((a, b) => String(b.effective_from || '').localeCompare(String(a.effective_from || '')));
  return rules[0] || null;
}

export function ruleText(row) {
  const rule = latestRule(row);
  if (!rule) {
    const salary = Number(row.monthly_salary || 0);
    return salary ? `급여 ${salary.toLocaleString('ko-KR')}원` : '급여 조건 없음';
  }
  const salary = rule.salary_enabled ? `급여 ${Number(rule.monthly_salary || 0).toLocaleString('ko-KR')}원` : '급여 제외';
  const source = rule.incentive_source || (rule.incentive_enabled === false ? 'none' : 'direct');
  const incentive = source === 'incentive_total'
    ? '인센티브 관리 금액'
    : source === 'none'
      ? '인센티브 제외'
      : `${Number(rule.incentive_base_included_count || 0) > 0 ? `${Number(rule.incentive_base_included_count || 0).toLocaleString('ko-KR')}장 포함 · ` : ''}${Number(rule.incentive_unit_price || 0).toLocaleString('ko-KR')}원/장`;
  return `${rule.effective_from || '-'}부터 · ${salary} · ${incentive}`;
}
